// extracted by mini-css-extract-plugin
export var active = "Menu-module--active--30b0f";
export var hamburger = "Menu-module--hamburger--571b0";
export var menu = "Menu-module--menu--f6559";
export var menuToggle = "Menu-module--menu-toggle--6e95b";
export var navigation = "Menu-module--navigation--2f599";